<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogContent>
        <ng-container *ngIf="isLoaded$ | async; else preloaderTemplate">
            <div cdkDropListGroup class="grid grid-cols-2 grid-rows-1 gap-2 w-full h-full overflow-hidden">
                <!-- Левая часть -->
                <fui-card [hasBorder]="false" class="card-tree-all">
                    <div
                        class="flex-none h-8 text-on-surface font-medium px-2 flex items-center rounded-t bg-surf-container-lowest truncate"
                    >
                        {{ dictionary.system_settings_table_dialog_all }}
                    </div>
                    <app-input-search
                        #inputSearchAll
                        (inputEvent)="filterService(dataAll, $event, 'all')"
                        [showToggleArrowButtons]="true"
                        [disableDown]="filterState.all.disableDown"
                        [disableUp]="filterState.all.disableUp"
                        [label]="dictionary.input_search_placeholder"
                        (switching)="switchRowInFilteredData($event, 'all')"
                    >
                    </app-input-search>

                    <!-- Дерево доступных колонок -->
                    <div class="grow overflow-auto rounded-b bg-surf-container-lowest" #scrollableContainerAll>
                        <mat-tree
                            id="fields-tree"
                            [dataSource]="dataSourceAll"
                            [treeControl]="treeControlAll"
                            cdkDropList
                            cdkDropListSortingDisabled
                            cdkDropListConnectedTo="table-fields-tree"
                        >
                            <mat-tree-node
                                *matTreeNodeDef="let node; when: firstLevel"
                                class="flex items-center justify-between gap-2 px-2 h-8 border-b border-outline-variant bg-surf-container-lowest hover:bg-accent-container"
                            >
                                <div class="flex-none">
                                    <fui-button
                                        matTreeNodeToggle
                                        type="button-icon"
                                        height="slim"
                                        color="flat"
                                        borderRadius="circle"
                                        [icon]="treeControlAll.isExpanded(node) ? 'chevron-down' : 'chevron-right'"
                                    ></fui-button>
                                </div>
                                <div class="flex-auto">
                                    <div class="line-clamp-1 h-5">
                                        {{ node.name }}
                                    </div>
                                </div>
                            </mat-tree-node>
                            <mat-tree-node
                                *matTreeNodeDef="let node; when: secondLevel"
                                #itemRefDataAll
                                matTreeNodeToggle
                                data-id="{{ node.alias }}"
                                [class.node-highlight]="activeNode === node.alias"
                                cdkDrag
                                [cdkDragData]="node"
                                class="flex items-center justify-between gap-2 pl-10 pr-2 h-8 border-b border-outline-variant bg-surf-container-lowest hover:bg-accent-container cursor-grab"
                            >
                                <fui-icon [icon]="getFactorIcon(node)"></fui-icon>
                                <div class="flex-auto">
                                    <div [highlight]="highlightText.all" [text]="node.name" class="line-clamp-1 h-5">
                                        {{ node.name }}
                                    </div>
                                </div>
                                <div class="flex-none">
                                    <fui-button
                                        (clickEvent)="moveNodeBetweenTree(this.dataAll, this.dataSelected, node)"
                                        [title]="dictionary.system_add_alt"
                                        [type]="'button-icon'"
                                        [icon]="'plus-circle-outline'"
                                        [height]="'slim'"
                                        [color]="'neutral'"
                                        [borderRadius]="'circle'"
                                        [iconSize]="1"
                                    >
                                    </fui-button>
                                </div>
                            </mat-tree-node>
                        </mat-tree>

                        <!-- Ничего не найдено -->
                        <ng-container
                            *ngIf="dataSourceAll.data.length === 0 && (inputSearchAll.searchStr$ | async)?.length > 0"
                            [ngTemplateOutlet]="emptySearch"
                        >
                        </ng-container>
                    </div>
                </fui-card>

                <!-- Правая часть -->
                <fui-card [hasBorder]="false" class="card-tree-search">
                    <div
                        class="flex-none h-8 text-on-surface font-medium px-2 flex items-center rounded-t bg-surf-container-lowest truncate"
                    >
                        {{ dictionary.system_settings_table_dialog_select }}
                    </div>
                    <app-input-search
                        #inputSearchSelected
                        (inputEvent)="filterService(dataSelected, $event, 'select')"
                        [showToggleArrowButtons]="true"
                        [disableDown]="filterState.select.disableDown"
                        [disableUp]="filterState.select.disableUp"
                        (switching)="switchRowInFilteredData($event, 'select')"
                        [label]="dictionary.input_search_placeholder"
                    >
                    </app-input-search>

                    <!-- Дерево выбранных столбцов -->
                    <div class="grow overflow-auto rounded-b bg-surf-container-lowest" #scrollableContainerSelect>
                        <mat-tree
                            id="table-fields-tree"
                            [dataSource]="dataSourceSelect"
                            [treeControl]="treeControlSelect"
                            cdkDropList
                            (cdkDropListDropped)="drop($event)"
                        >
                            <mat-tree-node
                                data-id="{{ node.alias }}"
                                #itemRefDataSelect
                                [class.node-highlight]="activeNode === node.alias"
                                *matTreeNodeDef="let node; when: secondLevel"
                                cdkDrag
                                [cdkDragData]="node"
                                cdkDragBoundary="#table-fields-tree"
                                (cdkDragStarted)="dragStart()"
                                (cdkDragReleased)="dragEnd()"
                                class="flex items-center justify-between gap-2 pl-1 pr-3 h-8 border-b border-outline-variant bg-surf-container-lowest hover:bg-accent-container cursor-grab"
                            >
                                <ng-container *ngIf="!node.isUnion">
                                    <div class="flex-auto flex items-center gap-1">
                                        <div class="flex-none w-8 flex items-center justify-center">
                                            <fui-checkbox
                                                [checked]="nodeCheckbox[node.alias]"
                                                (changed)="nodeCheckbox[node.alias] = $event"
                                            ></fui-checkbox>
                                        </div>
                                        <div
                                            [highlight]="highlightText.select"
                                            [text]="node.name"
                                            class="flex-auto line-clamp-1 h-5"
                                        >
                                            {{ node.name }}
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="node.isUnion">
                                    <div class="flex-auto flex items-center gap-1.5">
                                        <div class="flex-none w-7 flex items-center justify-center">
                                            <fui-icon icon="vector-union"></fui-icon>
                                        </div>
                                        <div
                                            [highlight]="highlightText.select"
                                            [text]="node.name"
                                            class="flex-auto line-clamp-1 h-5"
                                        >
                                            {{ node.name }}
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="node.is_main">
                                    <fui-icon icon="star"></fui-icon>
                                </ng-container>
                                <ng-container *ngIf="node.is_sticky">
                                    <fui-icon icon="pin-outline"></fui-icon>
                                </ng-container>

                                <div class="flex items-center flex-none">
                                    <div>
                                        <fui-button
                                            (clickEvent)="moveNodeBetweenTree(dataSelected, dataAll, node)"
                                            [title]="dictionary.system_remove_input"
                                            [type]="'button-icon'"
                                            [icon]="'minus-circle-outline'"
                                            [height]="'slim'"
                                            [color]="'neutral'"
                                            [borderRadius]="'circle'"
                                            [iconSize]="1"
                                            [disabled]="dataSelected.length < 2"
                                        >
                                        </fui-button>
                                    </div>
                                    <div>
                                        <ng-container
                                            [ngTemplateOutlet]="kebabMenu"
                                            [ngTemplateOutletContext]="{ node }"
                                        />
                                    </div>
                                </div>
                            </mat-tree-node>
                        </mat-tree>

                        <!-- Ничего не найдено -->
                        <ng-container
                            *ngIf="
                                dataSourceSelect.data.length === 0 &&
                                (inputSearchSelected.searchStr$ | async)?.length > 0
                            "
                            [ngTemplateOutlet]="emptySearch"
                        >
                        </ng-container>
                    </div>
                </fui-card>
            </div>
        </ng-container>

        <!-- Скелетон -->
        <ng-template #preloaderTemplate>
            <div class="skeleton w-full h-10"></div>
        </ng-template>
    </ng-container>

    <!-- Кнопки диалога -->
    <ng-container dialogActions>
        <fui-button [label]="dictionary.system_save" [icon]="'content-save'" [height]="'mini'" (clickEvent)="save()">
        </fui-button>
        <fui-button
            [label]="dictionary.system_cancel"
            [color]="'light'"
            [icon]="'close'"
            [height]="'mini'"
            (clickEvent)="close()"
        >
        </fui-button>
        <fui-button
            *ngIf="data.tableService?.clearTableSettings"
            [matMenuTriggerFor]="menuTopPager"
            [title]="dictionary.system_actions"
            [color]="'light'"
            [type]="'button-icon'"
            [icon]="'dots-vertical'"
            [height]="'mini'"
        >
        </fui-button>
        <mat-menu #menuTopPager="matMenu">
            <button
                *ngIf="data.tableService?.clearTableSettings"
                mat-menu-item
                type="button"
                class="settings-table-mat-menu-item"
                (click)="clearTableSettings()"
            >
                {{ dictionary.system_reset_table_settings }}
            </button>
        </mat-menu>
    </ng-container>
</app-dialog>

<!-- Шаблон области "Ничего не найдено" -->
<ng-template #emptySearch>
    <div class="h-full w-full flex items-center justify-center">
        <div class="grow flex flex-col items-center justify-center gap-8">
            <fui-empty-state
                [icon]="'text-box-search'"
                [iconSize]="4"
                [text]="dictionary.rubricator_search_empty"
            ></fui-empty-state>
        </div>
    </div>
</ng-template>

<!-- Кебаб меню для выбранных колонок -->
<ng-template #kebabMenu let-node="node">
    <fui-button
        [title]="dictionary.system_actions"
        [type]="'button-icon'"
        [icon]="'dots-vertical'"
        [height]="'slim'"
        [color]="'neutral'"
        [borderRadius]="'circle'"
        [iconSize]="1"
        [cdkMenuTriggerFor]="kebabMenuPopup"
    >
    </fui-button>
    <ng-template #kebabMenuPopup>
        <div fuiMenu classList="setting-table-mat-menu-rounded-bottom">
            <button fuiMenuItem (click)="openNameDialog('rename', node, [])">
                <fui-icon icon="pencil-outline"></fui-icon>
                {{ dictionary.system_rename }}
            </button>
            <button fuiMenuItem (click)="moveNode(node, true)">
                <fui-icon icon="arrow-up"></fui-icon>
                {{ dictionary.system_up }}
            </button>
            <button fuiMenuItem (click)="moveNode(node, false)">
                <fui-icon icon="arrow-down"></fui-icon>
                {{ dictionary.system_way_down }}
            </button>
            <button fuiMenuItem *ngIf="!node.is_sticky" (click)="node.is_sticky = true">
                <fui-icon icon="pin-outline"></fui-icon>
                {{ dictionary.system_to_fix }}
            </button>
            <button fuiMenuItem *ngIf="node.is_sticky" (click)="node.is_sticky = false">
                <fui-icon icon="pin"></fui-icon>
                {{ dictionary.system_unpin }}
            </button>
            <button fuiMenuItem *ngIf="!node.is_main" (click)="setMainColumn(node)">
                <fui-icon icon="star"></fui-icon>
                {{ dictionary.system_make_main }}
            </button>
            <button fuiMenuItem *ngIf="node.is_main" (click)="node.is_main = false">
                <fui-icon icon="star-outline"></fui-icon>
                {{ dictionary.system_make_minor }}
            </button>
            <button
                fuiMenuItem
                *ngIf="node.columns.length === 0"
                [disabled]="hasNodeCheckboxChecked()"
                (click)="unionNode()"
            >
                <fui-icon icon="vector-union"></fui-icon>
                {{ dictionary.system_combine }}
            </button>
            <button fuiMenuItem *ngIf="node.columns.length > 1" (click)="unUnionNode(node)">
                <fui-icon icon="vector-combine"></fui-icon>
                {{ dictionary.system_disconnect }}
            </button>
        </div>
    </ng-template>
</ng-template>
